// FX helpers - MUST mirror services/finance-service/src/money.js convertCents
// exactly (CLAUDE.md: previews use the identical cents arithmetic). One
// deliberate deviation: the backend throws on invalid input, the preview
// returns 0 so a half-typed rate never crashes the form.

/**
 * Converts integer cents at a rate (CHF per 1 unit of foreign currency,
 * NUMERIC(18,6) as string or number). Cents in, cents out, rounded half-up -
 * never round in francs.
 * @param {number} fxCents
 * @param {number|string} rate
 * @returns {number}
 */
export function convertCents(fxCents, rate) {
  const r = typeof rate === 'string' ? Number(rate) : rate;
  if (!Number.isFinite(fxCents) || !Number.isFinite(r) || r <= 0) {
    return 0;
  }
  return Math.round(fxCents * r);
}

/**
 * CHF equivalent of a foreign-currency amount string, as a fixed-2 string.
 * @param {string|number} amountStr
 * @param {number|string} rate
 * @returns {string}
 */
export function chfEquivalent(amountStr, rate) {
  const cents = Math.round(Number(amountStr || 0) * 100);
  return (convertCents(cents, rate) / 100).toFixed(2);
}
